<template>
    <edit-resource
        :title="title"
        :form="form"
        @close="$emit('close')"
        @submit="saveReason"
    >
        <div class="w-600">
            <simple-input :static-id="'rejectReasonInput'" v-model="form.title"/>
        </div>
    </edit-resource>
</template>

<script>
import EditResource from './EditResource.vue';
import Form from '../../etc/forms/Form';
import Translatable from '../forms/Translatable.vue';
import * as rejectReasonService from '../../services/RejectReasonService';
import { normalizeJson } from '../../../shared/helpers';
import TextArea from '../forms/TextArea.vue';
import RejectReason from '../../models/RejectReason';
import SvgIcon from './SvgIcon.vue';
import SimpleInput from '../forms/Input.vue'
import {useRepo} from "pinia-orm";

function getFields () {
    return [
        { name: 'title', value: null },
    ];
}

export default {
    components: {
        'edit-resource': EditResource,
        'simple-textarea': TextArea,
        'translatable': Translatable,
        'simple-input': SimpleInput,
        'svg-icon': SvgIcon,
    },
    props: {
        reason: RejectReason,
    },
    data: function () {
        return {
            form: this.generateForm(),
        }
    },
    computed: {
        title () {
            return this.$t(this.reason ? 'general.edit_subject' : 'general.add_subject', { subject: this.$t('settings.reject_reasons.single') })
        }
    },
    methods: {
        generateForm () {
            let fields = getFields();

            if (this.reason) {
                fields.forEach((field, index) => {
                    fields[index].value = JSON.parse(JSON.stringify(this.reason[field.name]));
                });
            }

            return new Form(fields);
        },

        async saveReason () {
            if (this.reason && this.reason.id) {
                await this.updateReason();
            } else {
                await this.createReason();
            }

            this.$emit('close');
        },
        updateReason () {
            return this.form.submit(data => {
                data = this.formatBeforeSave(data);
                return rejectReasonService.update(this.reason.id, data);
            }).then(result => {
                return useRepo(RejectReason).save(normalizeJson(result));
            });
        },
        createReason () {
            return this.form.submit(data => rejectReasonService.store(this.formatBeforeSave(data)))
                .then(result => {
                    useRepo(RejectReason)
                        .save(useRepo(RejectReason)
                            .where('order', value => value >= result.attributes.order)
                            .get()
                            .map(reason => ({
                                id: reason.id,
                                order: reason.order + 1,
                            }))
                        );
                    return result;
                }).then(result => {
                    return useRepo(RejectReason).save(normalizeJson(result));
                });
        },
        formatBeforeSave (data) {
            let body = {
                data: { attributes: {}},
            };

            body.data.attributes = {...data};

            return body;
        }
    },
}
</script>
